import { Box, Button, Stack } from '@mui/material';
import * as React from 'react';
import { Outlet, useNavigate } from 'react-router';
import ProjectProvider from '../Contexts/Providers/ProjectProvider';
import ProjectLayoutInner from './ProjectLayoutInner';

export interface IProjectLayoutProps extends React.PropsWithChildren<{}> {

}

export default function ProjectLayout(props: IProjectLayoutProps) {

    return (
        <ProjectProvider>
            <ProjectLayoutInner />
        </ProjectProvider>
    );
}
